import React, { useState } from 'react';
import { useOktaAuth } from "@okta/okta-react";
import "react-bootstrap/dist/react-bootstrap.min.js";
import {Row, Nav, Container, Button, Form, Navbar, NavDropdown, InputGroup, Toast} from "react-bootstrap"
import '../css/Home.css';
import logo from "../img/ksst_logo.png";


function Home() {
    const [submitting, setSubmitting] = useState(false);
    const [secretData, setSecretData] = useState({secretData: ""});
    const [encryptedUrl, setEncryptedUrl] = useState("");
    const [duration, setDuration] = useState({duration: "3600"});
    const { oktaAuth, authState } = useOktaAuth();
    const [validated, setValidated] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [showA, setShowA] = useState(true);
    const [errorMsg, setErrorMsg] = useState({error: "", transID: ""});
    const [isError, setIsError] = useState(false);
    const toggleIsError = () => setIsError(!isError);


    const handleSubmit = async event => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setFirstLoad(false);
        }
        else {
            event.preventDefault();
            setValidated(true);

            let reqSettings = {
                method: "POST",
                // Data will be serialized and sent as json
                body: JSON.stringify({
                    duration: duration['duration'],
                    secret_data: secretData['secretData']
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }
            if (authState.isAuthenticated) {
                reqSettings.headers['Authorization'] = "Bearer " + authState.accessToken.accessToken
            }

            const response = await fetch(process.env.PUBLIC_URL + "/api/v1/store", reqSettings)
                .then((response) => response.json())
                .then((data) => function (data) {
                    if (data.id){
                        setEncryptedUrl(window.location.href + "retrieve/" + data.id + "/" + data.auth);
                        setTimeout(() => setSubmitting(true), 10);
                    }
                    else {
                        setErrorMsg({error: data.err, transID: data.transaction_id});
                        setIsError(true);
                    }


                }(data))
                .catch((error) => {
                    console.log(error)
                });


        }

    }

    const login = async () => oktaAuth.signInWithRedirect();

    //TODO: Looks like this is required, maybe do something differentQ
    if(!authState) {
        return <div>Loading...</div>;
    }

    const setDurationChange = async event => {
        setDuration({
            duration: event.target.value
        })

    };

    const setSecretDataChange = async event => {
        setSecretData({
            secretData: event.target.value
        });
    };

    return(
        <>
            <Navbar bg="light" variant="light">

                    <Navbar.Brand href="/">
                        <img src={logo} style={{width:100, height:100, marginTop: -7}} />
                    </Navbar.Brand>
                    <Nav className="ml-auto">
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/api/v1/swagger/index.html">API</Nav.Link>
                        {!authState.isAuthenticated &&

                            <Nav.Link onClick={login}>Login</Nav.Link>
                        }
                        {authState.isAuthenticated &&

                            <NavDropdown title={authState.idToken.claims.name} id="basic-nav-dropdown" >

                                <NavDropdown.Item href="/logout" >
                                    Sign Out
                                </NavDropdown.Item>
                            </NavDropdown>
                        }
                    </Nav>
            </Navbar>

            <div className="custom_center">
                <h3> Kohl's Secret Sharing Tool</h3>


            </div>
            <br/>
            <div className="custom_center">
                <p>Allows for secure secret sharing via the use of a one-time link</p>
            </div>
            <hr className="hr_width"></hr>
            <div className="position: relative">
                <Toast variant="warning" show={isError} onClose={toggleIsError} className="move_right">
                    <Toast.Header closeButton={false}>
                        <strong className="mr-auto">Error Message        </strong>
                        <Button className="float-end" variant="light" onClick={() => setIsError(false)}>x</Button>

                    </Toast.Header>
                    <Toast.Body>
                        Error: {errorMsg.error}
                        <br></br>
                        Transaction ID: {errorMsg.transID}
                    </Toast.Body>

                </Toast>
            </div>
            {!submitting &&
                <Container fluid className="roomfac">

                    <Form noValidate validated={validated} onSubmit={handleSubmit} >
                        <InputGroup hasValidation>
                            <Form.Control required className="textarea"
                                          rows="10" as="textarea" type="text" aria-label="With textarea"
                                          value={secretData['secretData']}
                                          isInvalid={!secretData['secretData'] && !firstLoad}
                                          placeholder="Enter your secret data here and select a duration below.
                                          " name="secretData" onChange={setSecretDataChange}/>
                            <Form.Control.Feedback type="invalid">
                                Cannot submit an empty secret.
                            </Form.Control.Feedback>
                        </InputGroup>
                    <br/>

                        <Row>
                            <InputGroup className="mb-2 padding_left">
                                <InputGroup.Text>Duration</InputGroup.Text>
                                {!authState.isAuthenticated &&
                                    <Form.Select className="home_select" name="duration"
                                                 onChange={setDurationChange}>
                                        <option value="3600">1 hour</option>
                                    </Form.Select>
                                }
                                {authState.isAuthenticated &&
                                    <Form.Select className="home_select" name="duration"
                                                 onChange={setDurationChange}>
                                        <option value="3600">1 hour</option>
                                        <option value="86400">1 day</option>
                                        <option value="604800">1 week</option>
                                    </Form.Select>
                                }

                                <Button variant="flat" className="ml-2" type="submit">
                                    Generate Url
                                </Button>
                            </InputGroup>

                        </Row>
                        <div  className="custom_center red">
                            <p>
                                Generated link will be valid for the selected duration
                                <br/>
                                Once expired secret contents <b>cannot</b> be retrieved
                            </p>

                        </div>
                    </Form>
                </Container>
            }
            {submitting &&
                <Container fluid className="roomfac">
                    <Form.Control type="text" placeholder= {encryptedUrl} aria-label="Disabled input example" value={encryptedUrl} readOnly/>
                    <div className="mt-3 text-center">
                        <p>
                            Share this link with the user that you want to send the secret to
                            <br/>
                            <b>Link is valid for one-time use. Secret contents are automatically destroyed after retrieval</b>
                        </p>
                        <Button variant="flat"  onClick={() => navigator.clipboard.writeText(encryptedUrl)}>
                            Copy
                        </Button>
                    </div>
                </Container>
            }
        </>
    )
}

export default Home;
